<template>
  <v-btn-toggle
    class="d-flex my-4"
    :value="isEnabled ? 0 : undefined"
  >
    <v-btn
      v-bind="{ ...$attrs }"
      v-on="{ ...$listeners }"
      block
    >
      <v-icon left>mdi-square-edit-outline</v-icon>
      <span class="text-caption secondary--text font-weight-bold">
        {{ $t("commons.edit") }} {{ $t("commons.informations") }}
      </span>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: "EditInfoButton",
  props: {
    isEnabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
